/* import __COLOCATED_TEMPLATE__ from './drilldown-side-drawer-skeleton.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();